<template>
  <!-- AB#21698: product (fixed) logos the customer set to No Fill - leave them out of production -->
  <div v-if="logos.length > 0" class="w-full pt-2 my-2" data-testid="order-product-no-fill-logos">
    <h4 class="mb-2 text-2xl font-semibold">Product logos - No Fill</h4>
    <p class="mb-2 text-sm text-ink-soft">
      The customer hid these product logos on their uploaded design. Leave them out of production.
    </p>
    <ul class="list-disc pl-6">
      <li v-for="logo in logos" :key="`${logo.side}|${logo.title}`">
        <span class="font-medium">{{ logo.title }}</span>
        <span v-if="logo.side" class="text-ink-soft"> ({{ logo.side }})</span>
        - No Fill
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { hiddenFixedLogos } from '@/utils/fixedLogoNoFill';

const props = defineProps<{
  product: { design_id?: number | string | null; fixed_logo_overrides?: unknown } | null;
}>();

const logos = computed(() => hiddenFixedLogos(props.product));
</script>
